module.exports = __webpack_public_path__ + "static/media/service6.d0dfe178.svg";